export const getInlineAdConfig = (adCount) => {
  const ampSlotSize = adCount > 1 ? [[320, 480], [300, 250]] : [300, 250];
  return {
    type: 'INLINE_ADVERT',
    props: {
      extraClassNames: {
        '-full-width': true,
      },
      id: `refresh-inline_${adCount}`,
      isSpaceReserved: true,
      label: 'Advertisement - Article continues below',
      slotSize: [[300, 250], 'fluid'],
      sizeMapping: [
        {
          viewport: [768, 0],
          slot: [[728, 90], [300, 250], 'fluid'],
        },
        {
          viewport: [980, 0],
          slot: [[970, 250], [970, 90], [728, 90], 'fluid'],
        },
      ],
      ampSlotSize,
      targeting: {
        position: `inline_${adCount}`,
        placement: `inline_${adCount}`,
        refresh: 'yes',
      },
    },
  };
};
